import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ua2hkh2rd: FaireProductEntity = {
  token: "p_3ua2hkh2rd",
  type: "product",
  name: "Solid Color Cropped Tank Top and Jogger Pants Set (S-XL)",
  brandToken: "b_fpqcwkn7v8",
  brandName: "66DISCO",
  imageUrl:
    "https://cdn.faire.com/fastly/39dc75ddc97347429392191d2368abddd61101782b3b1c17078e09b2888e6d5d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08cee2978983654947619e0720ac60d0e0cd39a3ecd3bed8c945f320776f351e.jpeg",
    "https://cdn.faire.com/fastly/77bd192150baa6319af2b64b18bc753ff13924188e33642b7813bd7ebe933204.jpeg",
    "https://cdn.faire.com/fastly/4cc1dc4917e75b1fd70af03062aa9af68624715d11e90562539e63555f08d249.jpeg",
    "https://cdn.faire.com/fastly/102a6c8ea94c0dc1900fac7236a308cf8009962816f321b69ef523fc1cf6ea66.png",
    "https://cdn.faire.com/fastly/dd5cbf7a806eebd3bf09d31167138d05e20815ae10caf23d4181268becfc3770.png",
    "https://cdn.faire.com/fastly/e7c329d3cfef479b3389c4e8c1be29c9c8c8622edae8c080bff27d3bc0eb17e1.jpeg",
    "https://cdn.faire.com/fastly/fcb5edc351f8dc18ee88bc6d49c75542b8f247e5c3204f05457eb778c27cc262.jpeg",
    "https://cdn.faire.com/fastly/f132f09544f3d0b7770a3c7464a55c7a7db56ce2509e541b39f9c5a602532efb.jpeg",
  ],
  priceDollars: 28.4,
  description:
    "🎀Material: 95%Cotton+5%Elastane\n😍Why You’ll Love It?\n\nMinimalist solid colors provide a fresh and charming look for this coordinated set\nSporty cropped tank tops ensure a modern and high character frame for the design\nClassic jogger pants offer a relaxed and versatile aesthetic for daily wear\nSoft matching sets create a comfortable and playful silhouette for lounging or errands\n\n💌Note: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options!",
  tags: [],
  msrpDollars: 56.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:04.164Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
